var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.contents.length>0)?_c('div',{staticClass:"LINEMESSAGE-BOX",style:([
  {
    display: 'flex',
    flexDirection: _vm.item.layout === 'vertical' ? 'column' : 'row',
    alignItems: _vm.item.layout === 'baseline' ? 'baseline' :_vm.item.alignItems,
    justifyContent: _vm.item.justifyContent
  },
  _vm.item.flex ? { flex: _vm.item.flex } : {},
  _vm.item.background?{
    background: _vm.item.background
  }:{ backgroundColor: _vm.item.backgroundColor },
  _vm.item.paddingAll?{
    padding: _vm.item.paddingAll
  }:{},
  _vm.item.paddingTop?{ paddingTop: _vm.item.paddingTop}:{},
  _vm.item.paddingStart?{ paddingTop: _vm.item.paddingStart}:{},
  _vm.item.paddingBottom?{ paddingTop: _vm.item.paddingBottom}:{},
  _vm.item.paddingEnd?{ paddingTop: _vm.item.paddingEnd}:{},
  _vm.item.margin?{
    marginTop: _vm.item.margin === 'xs' ? '2px'
    : _vm.item.margin === 'sm' ? '4px'
    : _vm.item.margin === 'md' ? '8px'
    : _vm.item.margin === 'lg' ? '12px'
    : _vm.item.margin === 'lg' ? '12px'
    : _vm.item.margin === 'xl' ? '16px'
    : _vm.item.margin === 'xxl' ? '20px'
    : _vm.item.margin
  }:{},
  _vm.item.borderWidth?{
    borderWidth: _vm.item.borderWidth,
    borderStyle: 'solid'
  }:{},
  _vm.item.borderColor?{
    borderColor: _vm.item.borderColor
  }:{},
  _vm.item.spacing?{
    gap: _vm.item.spacing === 'xs' ? '2px'
    : _vm.item.spacing === 'sm' ? '4px'
    : _vm.item.spacing === 'md' ? '8px'
    : _vm.item.spacing === 'lg' ? '12px'
    : _vm.item.spacing === 'lg' ? '12px'
    : _vm.item.spacing === 'xl' ? '16px'
    : _vm.item.spacing === 'xxl' ? '20px'
    : _vm.item.spacing
  }:{},
  { position: _vm.item.position || 'relative' },
  _vm.item.position==='absolute'?{
    top: _vm.item.offsetTop,
    bottom: _vm.item.offsetBottom,
    left: _vm.item.offsetStart,
    right: _vm.item.offsetEnd,
    alignItems: 'center',
    justifyContent: 'center'
  }:{},
  _vm.item.height?{ height: _vm.item.height}:{},
  _vm.item.width?{ width: _vm.item.width}:{width: '-webkit-fill-available'},
  _vm.item.cornerRadius?{
    borderRadius: _vm.item.cornerRadius
  }:{}
])},[_vm._l((_vm.item.contents),function(row,r){return [(row)?_c('Selector',{key:r,attrs:{"item":row,"index":r}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }